"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteEmployeeAccessService = exports.authSuiteEmployeeAccessService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var requestRoute = "employeeAccess";
var entitledEmailRequestRoute = "".concat(requestRoute, "/entitledEmail");
var getEmployeeDetails = function () {
    var path = "".concat(requestRoute, "/employee");
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: path,
    });
};
var defineEntitledEmail = function (request) {
    var payload = {
        email: request.email,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: entitledEmailRequestRoute,
    });
};
var removeEntitledEmail = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.delete({
        path: entitledEmailRequestRoute,
    });
};
exports.authSuiteEmployeeAccessService = {
    getEmployeeDetails: getEmployeeDetails,
    defineEntitledEmail: defineEntitledEmail,
    removeEntitledEmail: removeEntitledEmail,
};
var AuthSuiteEmployeeAccessService = /** @class */ (function () {
    function AuthSuiteEmployeeAccessService() {
        return exports.authSuiteEmployeeAccessService;
    }
    return AuthSuiteEmployeeAccessService;
}());
exports.AuthSuiteEmployeeAccessService = AuthSuiteEmployeeAccessService;
